import * as React from 'react';
import { useSelector } from 'react-redux';
import { PublicationPrice } from './PublicationPrice';
import { formatMoney, pluralDays } from '../../../../../../utils/string';
import { EPlacingType } from '../../../../../../types/reducers/publishTerms';
import { NBSP } from '../../../../../../constants/symbols';
import { selectIsMobileLayout } from '../../../../../../selectors/layout';
import {
  selectActivePlacingType,
  selectPaidPublication,
} from '../../../../../../reducers/v2/paidPublication/selectors';
import { selectActivePackage } from '../../../../../../reducers/v2/publicationPackages/selectors';

export const PublicationPriceContainer = () => {
  const placingType = useSelector(selectActivePlacingType);
  const activePackage = useSelector(selectActivePackage);
  const isMobile = useSelector(selectIsMobileLayout);
  const { price: publicationPrice, isPaid, days: publicationDays } = useSelector(selectPaidPublication);

  const { days: packageDays = 1, price: packagePrice = 0 } = activePackage || {};

  if (placingType === EPlacingType.package) {
    const header = isMobile ? 'Публикация включена в пакет' : undefined;
    const title = isMobile
      ? `Вам не${NBSP}надо отдельно платить за${NBSP}публикацию${NBSP}— она входит в${NBSP}состав пакета`
      : 'Публикация включена в пакет';

    return (
      <PublicationPrice
        discountPrice={publicationPrice ? formatMoney(publicationPrice) : null}
        price={packagePrice}
        days={pluralDays(packageDays, { excludeOne: true })}
        hintHeader={header}
        hintTitle={title}
      />
    );
  }

  // Объявление редактируется и пользователь платил деньги за публикацию (в некоторых регионах публикация бесплатна)
  if (isPaid && publicationPrice) {
    const header = isMobile ? 'Публикация уже оплачена' : undefined;
    const title = isMobile
      ? `Вам не${NBSP}надо отдельно платить за${NBSP}публикацию${NBSP}— вы${NBSP}оплатили её${NBSP}раньше`
      : 'Публикация уже оплачена';

    return (
      <PublicationPrice
        discountPrice={formatMoney(publicationPrice)}
        price={0}
        days={pluralDays(publicationDays, { excludeOne: true })}
        hintHeader={header}
        hintTitle={title}
      />
    );
  }

  return (
    <PublicationPrice
      discountPrice={null}
      price={publicationPrice}
      days={pluralDays(publicationDays, { excludeOne: true })}
    />
  );
};
